import React, { useState, useEffect, useCallback } from 'react';
import { makeStyles } from '@mui/styles';
import _ from 'underscore';
import { Page, Header } from 'components';

import { ManagementForm } from './components';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	sitelist: {
		marginTop: theme.spacing(6)
	}
}));

const AcceptanceManagement = () => {
	const classes = useStyles();

	return (
		<Page className={classes.root} title="Acceptance">
			<Header module="Acceptance" view="Management" />
			<ManagementForm />
		</Page>
	);
};

export default AcceptanceManagement;
